import React, { useState } from 'react';
import { resumeAPI } from '../../services/api';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  modal: {
    background: '#fff',
    padding: '30px',
    borderRadius: '12px',
    maxWidth: '500px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
  },
  title: {
    marginTop: 0,
    color: '#2d3748',
    fontSize: '24px',
    fontWeight: '700'
  },
  text: {
    color: '#4a5568',
    fontSize: '16px',
    lineHeight: '1.5',
    marginBottom: '20px'
  },
  buttonContainer: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    marginTop: '20px'
  },
  acceptButton: {
    padding: '12px 24px',
    backgroundColor: '#3182ce',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  },
  declineButton: {
    padding: '12px 24px',
    backgroundColor: '#e2e8f0',
    color: '#4a5568',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  }
};

const ATSRewriteOffer = ({ resumeFile, jdInput, onRewriteComplete, onDecline }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleRewrite = async () => {
    setIsProcessing(true);
    try {
      const formData = new FormData();
      formData.append('file', resumeFile);
      
      const response = await resumeAPI.atsRewrite(formData);
      
      if (response.data?.status === 'success' && response.data?.rewritten_resume) {
        // Create a new text file from the rewritten content
        const rewrittenText = response.data.rewritten_resume;
        const newFileName = resumeFile.name.replace(/\.[^/.]+$/, "") + "_ATS_Optimized.txt";
        const newFile = new File([rewrittenText], newFileName, {
          type: "text/plain",
          lastModified: new Date().getTime()
        });
        
        onRewriteComplete(newFile);
      } else {
        // Fallback on unexpected response
        onDecline();
      }
    } catch (error) {
      console.error("ATS rewrite failed:", error);
      onDecline();
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>ATS Optimization Recommended</h2>
        <p style={styles.text}>
          We detected that your resume format might not be fully ATS-friendly. 
          Would you like us to restructure it into a clean, parser-approved layout before proceeding?
        </p>
        <div style={styles.buttonContainer}>
          <button 
            style={styles.declineButton} 
            onClick={onDecline}
            disabled={isProcessing}
          >
            Skip for now
          </button>
          <button 
            style={styles.acceptButton} 
            onClick={handleRewrite}
            disabled={isProcessing}
          >
            {isProcessing ? 'Rewriting...' : 'Yes, Rewrite My Resume'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ATSRewriteOffer;
